document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('[data-header]');
  header?.querySelector('[data-menu-toggle]')?.addEventListener('click', () => header.querySelector('[data-mobile-menu]')?.classList.toggle('open'));
  header?.querySelector('[data-search-toggle]')?.addEventListener('click', () => header.querySelector('[data-mobile-search]')?.classList.toggle('open'));

  document.querySelectorAll('[data-quick-add]').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      event.stopPropagation();
      const button = form.querySelector('button');
      const original = button?.textContent;
      if (button) button.textContent = 'Adding…';
      try {
        await fetch(form.action, { method: 'POST', body: new FormData(form), headers: { 'Accept': 'application/json' }});
        if (button) button.textContent = 'Added ✓';
        setTimeout(() => { if (button && original) button.textContent = original; }, 1200);
      } catch (e) { if (button) button.textContent = original || 'Add to bag'; }
    });
  });

  document.querySelectorAll('[data-product-root]').forEach((root) => {
    const mainImage = root.querySelector('[data-main-product-image]');
    root.querySelectorAll('[data-product-thumb]').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        if (mainImage) mainImage.src = thumb.dataset.productThumb;
        root.querySelectorAll('[data-product-thumb]').forEach((t) => t.classList.remove('active'));
        thumb.classList.add('active');
      });
    });

    const form = root.querySelector('[data-product-form]');
    const variantsEl = root.querySelector('[data-variants-json]');
    if (form && variantsEl) {
      const variants = JSON.parse(variantsEl.textContent || '[]');
      const selected = [];
      root.querySelectorAll('[data-option-group]').forEach((group, groupIndex) => {
        const active = group.querySelector('.option-pill.active');
        selected[groupIndex] = active?.dataset.optionValueButton;
      });
      const updateVariant = () => {
        const variant = variants.find((v) => v.options.every((value, i) => value === selected[i]));
        if (!variant) return;
        const idInput = root.querySelector('[data-variant-id]');
        const priceEl = root.querySelector('[data-product-price]');
        const addButton = root.querySelector('[data-add-button]');
        if (idInput) idInput.value = variant.id;
        if (priceEl) priceEl.textContent = Shopify.formatMoney ? Shopify.formatMoney(variant.price, window.money_format || '${{amount}}') : (variant.price / 100).toFixed(2);
        if (addButton) {
          addButton.disabled = !variant.available;
          addButton.textContent = variant.available ? `🛍 Add to bag — ${priceEl?.textContent || ''}` : 'Out of stock';
        }
      };
      root.querySelectorAll('[data-option-value-button]').forEach((button) => {
        button.addEventListener('click', () => {
          const index = Number(button.dataset.optionIndex);
          selected[index] = button.dataset.optionValueButton;
          const group = button.closest('[data-option-group]');
          group?.querySelectorAll('.option-pill').forEach((b) => b.classList.remove('active'));
          button.classList.add('active');
          const label = group?.querySelector('[data-option-value]');
          if (label) label.textContent = button.dataset.optionValueButton || '';
          updateVariant();
        });
      });
    }

    const qtyInput = root.querySelector('[data-qty-input]');
    root.querySelector('[data-qty-minus]')?.addEventListener('click', () => { qtyInput.value = Math.max(1, Number(qtyInput.value || 1) - 1); });
    root.querySelector('[data-qty-plus]')?.addEventListener('click', () => { qtyInput.value = Number(qtyInput.value || 1) + 1; });
    root.querySelector('[data-share]')?.addEventListener('click', async () => { try { await navigator.clipboard.writeText(location.href); } catch(e) {} });
  });
});
